import { useContext, useEffect } from 'react';
import { UAParser } from 'ua-parser-js';

import AddEVCharger from './AddEVCharger';
import Address from './Address';
import BatteryInstallationSite from './BatteryInstallationSite';
import Contact from './Contact';
import CustomerHome from './CustomerHome';
import ElectricityBill from './ElectricityBill';
import Email from './Email';
import EnergyConsumption from './EnergyConsumption';
import EnlightenLogin from './EnlightenLogin';
import EnphaseCustomer from './EnphaseCustomer';
import Property from './Property';
import Sunlight from './Sunlight';
import UpgradeSystem from './UpgradeSystem';
import TechnicalSupport from './TechnicalSupport';
import UnableToService from './UnableToService';
import UpgradeMicroinverters from './UpgradeMicroinverters';
import UtilityProvider from './UtilityProvider';

import LayoutWrapper from '../components/LayoutWrapper';
import { Page } from '../enums';
import AppContext from '../../contexts/AppContext';
import ConfigContext from '../../contexts/ConfigContext';

interface HomeV2Props {
  page: string;
}

declare const Zuko: any;
declare const visitData: any;

export default function HomeV2({ page }: HomeV2Props) {
  const { setLoadedHome, setStartedFunnel, zukoSlug, setHideBookAppointment } =
    useContext(AppContext);
  const { testName } = useContext(ConfigContext);

  useEffect(() => {
    setStartedFunnel(true);
    setLoadedHome(true);

    let sourceData;
    try {
      sourceData = visitData.get();
    } catch (e: any) {
      sourceData = { source: 'direct', medium: 'none' };
    }

    const { device } = UAParser();
    Zuko.trackForm({
      target: document.querySelector('#root > div'),
      slug: zukoSlug || '',
    })
      .setAttribute('ab-test-variant', testName)
      .setAttribute('traffic-source', sourceData.source)
      .setAttribute('traffic-medium', sourceData.medium)
      .setAttribute(
        'device-model',
        !device.vendor && !device.model
          ? 'Unknown'
          : `${device.vendor ? device.vendor + ' ' : ''}${
              device.model ? device.model : ''
            }`
      )
      .trackEvent(Zuko.FORM_VIEW_EVENT);
  }, []);

  const getPageRoute = (): JSX.Element => {
    let pageRoute = <></>;
    let hideBookAppointment = false;

    switch (page) {
      // Enphase Customer Flow
      case Page.EnphaseCustomer:
        pageRoute = <EnphaseCustomer />;
        break;
      case Page.EnlightenLogin:
        pageRoute = <EnlightenLogin />;
        break;
      case Page.CustomerHome:
        pageRoute = <CustomerHome />;
        break;
      case Page.UpgradeSystem:
        pageRoute = <UpgradeSystem />;
        break;
      case Page.UpgradeMicroinverters:
        pageRoute = <UpgradeMicroinverters />;
        break;
      case Page.AddEVCharger:
        pageRoute = <AddEVCharger />;
        break;
      case Page.TechnicalSupport:
        pageRoute = <TechnicalSupport />;
        hideBookAppointment = true;
        break;
      case Page.BatteryInstallationSite:
        pageRoute = <BatteryInstallationSite />;
        break;
      case Page.EnergyConsumption:
        pageRoute = <EnergyConsumption />;
        break;

      // Current Funnel
      case Page.Property:
        pageRoute = <Property />;
        break;
      case Page.UnableToService:
        pageRoute = <UnableToService />;
        break;
      case Page.Sunlight:
        pageRoute = <Sunlight />;
        break;
      case Page.Address:
        pageRoute = <Address />;
        break;
      case Page.ElectricityBill:
        pageRoute = <ElectricityBill />;
        break;
      case Page.UtilityProvider:
        pageRoute = <UtilityProvider />;
        break;
      case Page.Email:
        pageRoute = <Email />;
        break;
      case Page.Contact:
        pageRoute = <Contact />;
        break;
    }
    setHideBookAppointment(hideBookAppointment);

    return pageRoute;
  };

  return <LayoutWrapper>{getPageRoute()}</LayoutWrapper>;
}
